import { useState } from 'react';

// Manual order origin/attribution — set by the team on the order page (existing
// orders) and in the manual-create form (WhatsApp/IG orders they enter
// themselves). Distinct from the auto-derived `traffic_source`. Base values +
// an "Autre…" free-text escape hatch so the team can record any channel.
export const ORIGIN_OPTIONS: { value: string; label: string }[] = [
  { value: 'meta_form',       label: 'Meta — Formulaire' },
  { value: 'meta_whatsapp',   label: 'Meta — WhatsApp' },
  { value: 'tiktok',          label: 'TikTok' },
  { value: 'instagram',       label: 'Instagram' },
  { value: 'whatsapp_manual', label: 'WhatsApp (manuel)' },
  { value: 'organic',         label: 'Organique' },
];

const OTHER = '__other__';

/** A human label for a stored origin value (known → French label, else raw). */
export function originLabel(value: string | null | undefined): string {
  if (!value) return '—';
  return ORIGIN_OPTIONS.find((o) => o.value === value)?.label ?? value;
}

export function OriginSelect({
  value,
  onChange,
  disabled,
  className,
}: {
  value: string | null;
  onChange: (v: string | null) => void;
  disabled?: boolean;
  className?: string;
}) {
  const isKnown = !!value && ORIGIN_OPTIONS.some((o) => o.value === value);
  // Start in free-text mode when the stored value isn't one of the presets.
  const [other, setOther] = useState<boolean>(!!value && !isKnown);
  const selectValue = other ? OTHER : (value ?? '');

  return (
    <div className={className}>
      <select
        value={selectValue}
        disabled={disabled}
        onChange={(e) => {
          const v = e.target.value;
          if (v === OTHER) { setOther(true); onChange(value && !isKnown ? value : ''); return; }
          setOther(false);
          onChange(v || null);
        }}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-400/40"
      >
        <option value="">— Aucune —</option>
        {ORIGIN_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
        <option value={OTHER}>Autre…</option>
      </select>
      {other && (
        <input
          type="text"
          value={value ?? ''}
          disabled={disabled}
          placeholder="Origine personnalisée"
          onChange={(e) => onChange(e.target.value || null)}
          className="mt-2 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-400/40"
        />
      )}
    </div>
  );
}
